import axios from "axios";
import { API_URL, AUTH_SAVE } from "../constants/constants";
// API_URL
const AXIOS = axios.create({
  baseURL: API_URL,
});

AXIOS.interceptors.response.use(
  (response) => response,
  (error) => {
    if (process.env.NODE_ENV !== "production") {
      console.log("GLOBAL_ERROR", error.response);
    }

    if (
      error.response?.status === 401 &&
      error.response?.data?.message === "Invalid token or token expired"
    ) {
      /**
       *  ||
      (error.response?.status === 403 &&
        error.response?.data?.message ===
          "Your account is not Active. Please contact administrator.")
       */
      localStorage.removeItem(`${AUTH_SAVE}`);
      window.location.reload();
    }

    return Promise.reject(error);
  }
);

export default AXIOS;
